import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import "./Navbar.css";
import logo from "../../assets/Images/Logo/logo.webp";
import UserApprovalModal from "../Approval/UserApprovalModal";
import Swal from 'sweetalert2';

const Navbar = ({ isMenuOpen, setIsMenuOpen, isUserLoggedIn, isAdminLoggedIn, handleLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isAuthPage = location.pathname === '/auth';

  const handleUsersButtonClick = () => {
    setIsModalOpen(true);
  };

  const sections = useMemo(
    () => ["Categories", "Services", "About", "Contact", "Stock List"],
    []
  );

  useEffect(() => {
    if (!isUserLoggedIn && !isAdminLoggedIn) return;
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight / 2;

      sections.forEach((section) => {
        const element = document.getElementById(section.toLowerCase());
        if (element) {
          const { top, bottom } = element.getBoundingClientRect();
          const elementTop = window.scrollY + top;
          const elementBottom = window.scrollY + bottom;

          if (scrollPosition >= elementTop && scrollPosition < elementBottom) {
            setActiveSection(section);
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [sections, isUserLoggedIn, isAdminLoggedIn]);

  // const handleScrollToSection = (section) => {
  //   if (section === "Stock List") {
  //     navigate("/stocklist-tanayajewel"); // Navigate to the products page
  //     setIsMenuOpen(false); // Close menu on mobile
  //     return;
  //   }
  //   setActiveSection(section);
  //   const element = document.getElementById(section.toLowerCase());
  //   if (element) {
  //     element.scrollIntoView({ behavior: "smooth" });
  //   }
  //   setIsMenuOpen(false); // Close menu on mobile after clicking a tab
  // };

  const handleScrollToSection = (section) => {
    if (section === "Stock List") {
      handleStockListClick();
      return;
    }
    setActiveSection(section);
    const element = document.getElementById(section.toLowerCase());
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMenuOpen(false);
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  const handleLoginClick = () => {
    navigate('/auth');
  };

  const handleStockListClick = () => {
    if (!isUserLoggedIn && !isAdminLoggedIn) {
      Swal.fire({
        icon: "warning",
        title: "Login Required",
        text: "You need to login first to view the stock list.",
      }).then(() => {
        navigate('/auth');
      });
      return;
    }
    navigate('/stocklist-tanayajewel');
    setIsMenuOpen(false);
  };

  const handleRoleSpecificLogout = () => {
    if (isAdminLoggedIn) {
      handleLogout("admin"); // Logout as admin
    } else if (isUserLoggedIn) {
      handleLogout("user"); // Logout as user
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo" onClick={handleLogoClick}>
          <img src={logo} alt="Company Logo" className="logo-image" loading="lazy" />
        </div>

        {/* Navigation Menu */}
        {/* {(location.pathname !== "/stocklist-tanayajewel" && location.pathname !== "/admin" && (isUserLoggedIn || isAdminLoggedIn)) && (
          <div className={`menu ${isMenuOpen ? "open" : ""}`}>
            <ul>
              {sections.map((tab) => (
                <li
                  key={tab}
                  className={activeSection === tab ? "active" : ""}
                  onClick={() => handleScrollToSection(tab)}
                >
                  {tab}
                </li>
              ))}
              {(isUserLoggedIn || isAdminLoggedIn) && (
                <li className="logout-buttons" onClick={handleRoleSpecificLogout}>
                  Logout
                </li>
              )}
            </ul>
          </div>
        )} */}

{!isAuthPage && (
          <div className={`menu ${isMenuOpen ? "open" : ""}`}>
            <ul>
              {/* Only show sections if not on admin page and (user is logged in or on home page) */}
              {(location.pathname !== "/admin" && location.pathname !== "/stocklist-tanayajewel" && (isUserLoggedIn || location.pathname === "/")) && (
                <>
                  {sections.map((tab) => (
                    <li
                      key={tab}
                      className={activeSection === tab ? "active" : ""}
                      onClick={() => handleScrollToSection(tab)}
                    >
                      {tab}
                    </li>
                  ))}
                </>
              )}
              {location.pathname !== "/admin" && (
                (isUserLoggedIn || isAdminLoggedIn) ? (
                  <li className="logout-buttons" onClick={handleRoleSpecificLogout}>
                    Logout
                  </li>
                ) : (
                  !isAuthPage && (
                    <li className="login-button" onClick={handleLoginClick}>
                      Login
                    </li>
                  )
                )
              )}
            </ul>
          </div>
        )}

        {/* Admin-Specific Buttons */}
        {location.pathname.startsWith("/admin") && isAdminLoggedIn && (
          <>
            {/* <div className="admin-buttons">
              <button className="users-button-admin" onClick={handleUsersButtonClick}>
                Users
              </button>
              <button className="logout-button-admin" onClick={handleRoleSpecificLogout}>
                Logout
              </button>
            </div> */}
            <div className={`menu ${isMenuOpen ? "open" : ""}`}>
              <ul>
                <li onClick={handleUsersButtonClick}>Users</li>
                <li onClick={handleRoleSpecificLogout}>Logout</li>
              </ul>
            </div>
          </>
        )}

{isModalOpen && <UserApprovalModal onClose={() => setIsModalOpen(false)} />}

        {/* Hamburger Icon for Mobile Menu */}
        {(location.pathname !== "/stocklist-tanayajewel" && (isUserLoggedIn || isAdminLoggedIn)) && (
          <div className="menu-icon" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <div className={`hamburger ${isMenuOpen ? "active" : ""}`}></div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;